// Module
var code = "<h2 id=\"loans-in-default\">Loans in Default?</h2> <p>See what happens when your loans default. </p> ";
// Exports
export default code;